import React from 'react'

const Nav = () => {
        return (
            <section className='comp abt'>
                <h2>نبذة عن موقعنا</h2>
                <div>
                    <p>يرحب بكم مطعم النخيل الرائع بأجوائه العربية الأصيلة والمذاقات الشهية التي تأسر الحواس. يعتبر مطعم النخيل وجهة مثالية لعشاق المأكولات الشرقية والعربية في قلب المدينة. يقدم المطعم تشكيلة متنوعة من الأطباق الشهية التي تناسب جميع الأذواق، بدءًا من المقبلات اللذيذة إلى الأطباق الرئيسية المتنوعة وحتى الحلويات الشهية.
                    تتميز تجربة تناول الطعام في مطعم النخيل بجوه الدافئ والضيافة العربية الأصيلة، حيث يمكنكم الاستمتاع بأجواء مريحة وتجربة طهي فريدة من نوعها. يضم المطعم أيضًا فريق محترف من الطهاة الذين يعملون بكل اهتمام لتقديم أشهى الأطباق بأجود المكونات.
                    سواء كنتم تبحثون عن وجبة شهية مع العائلة أو مكانًا رومانسيًا لتناول العشاء، فإن مطعم النخيل يوفر لكم البيئة المثالية للاستمتاع بتجربة طعام لا تُنسى. تفضلوا بزيارتنا اليوم واستمتعوا برحلة مذاقات لا مثيل لها.               
                    </p>
                </div>
            </section>
        )
}

export default Nav